import { render, staticRenderFns } from "./orderState.vue?vue&type=template&id=2bcd83e7"
import script from "./orderState.vue?vue&type=script&lang=js"
export * from "./orderState.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports